import { useCallback, useState } from "react"
import { baseURL } from "../config/api"

export const useFileDownload = () => {
  const [loadingMap, setLoadingMap] = useState<{ [key: string]: boolean }>({})

  const downloadFile = useCallback(async (fileUrlOrg: string, fileName?: string) => {
    let fileUrl = fileUrlOrg
    if (!fileUrl) return
    if (fileUrl.startsWith("/api")) {
      fileUrl = fileUrl.replace("/api", "")
    }

    setLoadingMap(prev => ({ ...prev, [fileUrlOrg]: true }))

    try {
      const response = await fetch(baseURL + fileUrl, { method: "GET" })
      if (!response.ok) throw new Error("Failed to fetch file")

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", fileName || "download")
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Download failed:", error)
    } finally {
      setLoadingMap(prev => ({ ...prev, [fileUrlOrg]: false }))
    }
  }, [])

  return { downloadFile, loadingMap }
}
